
import { footer } from '../../customWhiteLabel'
import { infosolucoes, infosolucoes2 } from '../../_mock/info_solucoes'
export default {
  data() {
    return {
      footer,
      sections: infosolucoes,
      sections2: infosolucoes2,
    }
  },
  methods: {
    saibaMais() {
      const whatsappUrl = `https://wa.me/${
        this.footer.botaoWhatsapp
      }?text=${encodeURIComponent(this.footer.messageConhecaNossasSolucoes)}`
      window.open(whatsappUrl, '_blanck')
    },
  },
}
